import {Badge, Button, Flex} from '@mantine/core'
import {useNavigate} from 'react-router-dom'
import {routes} from '../../routes.ts'
import {useSubscription} from '../../providers/subscription/useSubscription.ts'
import {IconAlertTriangle, IconArrowUp} from '@tabler/icons-react'

type Props = {
  current: number
  max: number
  loading: boolean
}

export const LimitedFeatureBadge = ({current, max, loading}: Props) => {
  const {activeSubscriptionTier} = useSubscription()
  const navigate = useNavigate()
  const warning = current >= max * 0.75
  const error = current > max

  if (loading) return null

  return (
    <Flex gap={5}>
      {warning && activeSubscriptionTier.canUpgrade && (
        <Button
          variant={'filled'}
          size={'compact-sm'}
          leftSection={<IconArrowUp size={18} />}
          radius={'xl'}
          fullWidth={false}
          onClick={() => navigate(routes.subscriptions.root.buildRoute())}
        >
          Upgrade
        </Button>
      )}
      <Badge
        size={'lg'}
        variant={'light'}
        color={error ? 'red' : warning ? 'orange' : undefined}
        fullWidth={false}
        leftSection={warning ? <IconAlertTriangle stroke={1} size={18} /> : undefined}
        title={`Limited to ${max}`}
      >
        {current}/{max}
      </Badge>
    </Flex>
  )
}
